import handlePlusQuantity from 'FORMS/handlePlusQuantity';
import handleSubtractQuantity from 'FORMS/handleSubtractQuantity';

const add_quantity = '[data-add-quantity]';
const subtract_quantity = '[data-subtract-quantity]';
const add_to_cart = '[data-add-to-cart]';

document.querySelectorAll('[data-purchase-form]').forEach(function(item){
  item.querySelector(add_quantity).addEventListener('click', handlePlusQuantity.bind(this, item));
  item.querySelector(subtract_quantity).addEventListener('click', handleSubtractQuantity.bind(this, item));
  item.querySelector(add_to_cart).addEventListener('click', handleAddToCart.bind(this, item));
});

function handleAddToCart(item, e) {
  e.preventDefault();
  var values = getFormValue(item);
  Shopify.addItem(values.id, values.quantity);
}

function getFormValue(form) {
  var elements = form.elements;
  var obj ={};
  for(var i = 0 ; i < elements.length ; i++){
      var item = elements.item(i);
      obj[item.name] = item.value;
  }

  return obj;
}
